import {
  content_v1_RequestDatasourceRequest,
  contentV1RequestDatasourceMutation,
} from '@antimatterhq/asl-api-ts-v1';
import { useMutation } from '@antimatterhq/ui/hooks/mutations/useMutation';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';

export const useCreateRequestDatasource = () => {
  const { workspace } = useWorkspace();
  return useMutation({
    mutationFn: ({ data }: { data: content_v1_RequestDatasourceRequest }) =>
      contentV1RequestDatasourceMutation({
        ...defaultOptions(),
      }).mutationFn!({ body: data, path: { workspace } }),
  });
};
